import { render, staticRenderFns } from "./Bank-Config.vue?vue&type=template&id=adea65fa&scoped=true"
import script from "./Bank-Config.vue?vue&type=script&lang=js"
export * from "./Bank-Config.vue?vue&type=script&lang=js"
import style0 from "./Bank-Config.vue?vue&type=style&index=0&id=adea65fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adea65fa",
  null
  
)

export default component.exports